import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

/** Shown by MsalAuthenticationTemplate when authentication itself fails. */
export const ErrorComponent = ({ error }) => (
  <Alert severity="error" sx={{ m: 2 }}>
    <AlertTitle>Sign-in failed</AlertTitle>
    {error?.errorMessage ||
      error?.message ||
      "An unexpected authentication error occurred. Please try again."}
  </Alert>
);
